module.exports = __webpack_public_path__ + "static/media/CheckCircleIcon.935065ad.svg";